module.exports = __webpack_public_path__ + "static/fajr-7bcf39e08216a336a5fd27a64ae3686d.jpeg";